import { create } from 'zustand'
import { ScheduleAppointmentStoreProps } from './ScheduleAppointment.types'
import {
  INITIAL_CLINIC_DATA,
  INITIAL_DATA_FORMATTED_DATA,
  INITIAL_HEALTH_INSURANCE_DATA,
  INITIAL_OBJECTIVE_DATA,
  INITIAL_PATIENT_DATA,
  INITIAL_SCHEDULE_LIST_DATA,
  INITIAL_DATA,
} from './ScheduleAppointment.constants'
import { persist } from 'zustand/middleware'

const store = persist<ScheduleAppointmentStoreProps>(
  set => ({
    patient: INITIAL_PATIENT_DATA,
    clinic: INITIAL_CLINIC_DATA,
    objectiveAppointment: INITIAL_OBJECTIVE_DATA,
    fittingAppointment: null,
    scheduleList: INITIAL_SCHEDULE_LIST_DATA,
    healthInsuranceData: INITIAL_HEALTH_INSURANCE_DATA,
    themesData: INITIAL_DATA,
    theoreticalApproachData: INITIAL_DATA,
    ageRangeData: INITIAL_DATA,
    genderData: INITIAL_DATA,
    dataFormatted: INITIAL_DATA_FORMATTED_DATA,
    persistDataForm: false,
    isPsychologist: false,
    resetSelectedPatient: () =>
      set(prevState => ({
        ...prevState,
        patient: INITIAL_PATIENT_DATA,
      })),
    resetSelectedClinic: () =>
      set(prevState => ({
        ...prevState,
        clinic: INITIAL_CLINIC_DATA,
      })),
    resetSelectedHealthInsurance: () =>
      set(prevState => ({
        ...prevState,
        healthInsuranceData: INITIAL_HEALTH_INSURANCE_DATA,
      })),
    updateValue(key, value) {
      set(state => ({
        ...state,
        [key]: value,
      }))
    },
  }),
  {
    name: '@conexa-useScheduleAppointmentStore',
    getStorage: () => sessionStorage,
  },
)

const useScheduleAppointmentStore = create(store)

export default useScheduleAppointmentStore
